import { Mapper } from "../../../../base/utils/mapper";
import { ReportByDateModel } from "../../../../domain/models/consult/report-by-date.model";
import { ReportByDateEntity } from '../entities/report-by-date.entity';



export class ReportByDateImplementationRepositoryMapper extends Mapper<ReportByDateEntity, ReportByDateModel> {
    mapFrom(param: ReportByDateEntity): ReportByDateModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ReportByDateModel): ReportByDateEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}